import { Header as Base } from './Header.js';
import { HeaderTop } from './HeaderTop.js';
import { HeaderMiddle } from './HeaderMiddle.js';
import { HeaderBottom } from './HeaderBottom.js';
export const Header = Object.assign(Base, {
    Top: HeaderTop,
    Middle: HeaderMiddle,
    Bottom: HeaderBottom,
});
//# sourceMappingURL=index.js.map